import React from 'react';

export const component = props => (
  <svg
    style={{ width: '100%' }}
    aria-hidden="false"
    aria-label={props.label}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 109.5 65"
  >
    <path
      fill={props.color}
      d="M0 0h59.6a.8.8 0 0 1 .8.6L69 19l.2.4.2-.4L78.1.4a.7.7 0 0 1 .7-.5h30.7l-.3.5-10 21.7a2.7 2.7 0 0 0-.3 1.1V65H10.6v-.6-41.1a2.4 2.4 0 0 0-.2-1Q5.4 11.3.2.5A3.9 3.9 0 0 0 0 .1zm68 23.8H13.2v38.7H68zm-.7-2.6l-.1-.4-8.4-18c-.2-.3-.4-.3-.7-.3H3.9l.2.6 8.3 17.6a.7.7 0 0 0 .7.5h54.2zm29 41.3V23.8H70.5v38.7zm-25-41.3h25.2a.5.5 0 0 0 .5-.4l8.5-18v-.3H80.4a.6.6 0 0 0-.6.3l-8.2 18-.2.4z"
    />
  </svg>
);

export default component;



// WEBPACK FOOTER //
// ./src/components/UI/Img/ServiceSVG/stockSVG.jsx